import VueDragscroll from "vue-dragscroll"

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.directive("v-dragscroll")
	vueApp.directive("v-dragscroll.x")
	vueApp.directive("v-dragscroll.y")
	vueApp.use(VueDragscroll)
})
